/* global axios */
import ApiClient from '../ApiClient';
import { getTimeOffset } from 'helpers/DateHelper';

class CrmDealsReportsAPI extends ApiClient {
  constructor() {
    super('reports/crm_deals', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  // `sections` (array) limita los bloques que calcula el backend; cada pantalla pide
  // sólo los que muestra. Sin el parámetro vienen todos.
  getSummary({ since, until, sections } = {}) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        sections: sections?.length ? sections.join(',') : undefined,
        // Alinea el agrupamiento por día/semana/mes con la zona del navegador.
        timezone_offset: getTimeOffset(),
      },
    });
  }
}

export default new CrmDealsReportsAPI();
